import profile from 'iz-ds-neo-alt/dist/system/i18n/jp/profile'

export default {
  ...profile,
	MSG_DATA_VALIDATOR: 'もう一度情報を確認してください!',
	MSG_INVALID_SIGNED_USER: 'ログインされていません。もう一度ログインしてください。',
	MSG_UPDATE_FAIL: '更新できませんでした。',
	MSG_UPDATE_SUCCESS: '正常に更新されました!',
}